import NavigationElements from "./pageElements/NavigationElements";
import { useEffect, useState } from "react";

export default function BlogPage(props) {
    const { displayNavigation, onUpdateDisplayNavigation } = props;
    const [blogPosts, setBlogPosts] = useState([]);

    useEffect(() => {
        const fetchBlogPosts = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_SERVER}/blogs/published`);
            const data = await response.json();
            setBlogPosts(data);
        };
        fetchBlogPosts();
    }, []);

    return (
        <>
            <NavigationElements
                displayNavigation={displayNavigation}
                onUpdateDisplayNavigation={onUpdateDisplayNavigation}
            />
            <div className="container mx-auto px-4 py-8 min-h-10">
                {blogPosts.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-full">
                        <img src="/no-data.png" alt="No Blogs Yet" className="w-1/2 h-[26.8rem] mb-4" />
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {blogPosts.map((post) => (
                          <div
                          key={post.id}
                          className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col h-[370px]"
                      >
                          <img
                              src={`${process.env.REACT_APP_MEDIA_SERVER}/${post.image}`}
                              alt={post.title}
                              className="w-full h-[180px] object-cover rounded-t-xl"
                          />
                          <div className="p-4 flex flex-col flex-grow">
                              <h2 className="text-lg font-bold text-[#005cb9] mb-1 truncate">
                                  {post.title || "Untitled"}
                              </h2>
                              <p className="text-sm text-blue-400 mb-2 truncate">
                                  {post.author || "Unknown"} | {post.date || "No Date"}
                              </p>
                              
                              <div className="mt-auto">
                                  <a
                                      href={`/blog/${post.id}`}
                                      className="text-sm text-[#005cb9] hover:text-[#004a94] font-medium inline-flex items-center"
                                  >
                                      Learn More <span className="ml-1">&rarr;</span>
                                  </a>
                              </div>
                          </div>
                      </div>
                      
                        ))}
                    </div>
                )}
            </div>
            
        </>
    );
}
